import React from "react";
import { Group, TooltipProps } from "@mantine/core";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import Tooltip from "@/components/atoms/Tooltip";

interface IconTooltipProps extends TooltipProps {
  width: number;
  height: number;
  icon: string;
  color: string;
}

const IconTooltip: React.FC<IconTooltipProps> = (props) => {
  const { color, width, height, icon, ...rest } = props;

  return (
    <Tooltip color={color} {...rest}>
      <Group justify={"flex-start"}>
        <SVGAsset name={icon} width={width} height={height} />
      </Group>
    </Tooltip>
  );
};

export default IconTooltip;
